import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  get pageNavNext() {
    return this.element.querySelector('#page-nav .next a');
  }

  get radioButtons() {
    return document.querySelectorAll('.mdc-radio');
  }

  submit() {
    var countCorrect = 0;

    this.radioButtons.forEach((radio) => {
      let input = radio.querySelector("input");

      if (input.checked) {
        this.hideAllExplanations(input.name);
        this.showSelectedExplanation(`#${input.id}-ex`);

        if (input.closest('.week3-radio').classList.contains('correct')) {
          countCorrect++;
        }
      }

    });

    if (countCorrect == 3) {
      this.enableNextNavigation();
    } else {
      this.showRetry();
    }
  }

  retry() {
    this.hideAllExplanations('week3-explanation');
    this.uncheckAll();
    this.showSubmit();
  }

  hideAllExplanations(cssClass) {
    this.element.querySelectorAll(`.${cssClass}`).forEach((explanation) => {
      explanation.style = 'display: none;';
    });
  }

  uncheckAll() {
    this.radioButtons.forEach((radio) => {
      radio.querySelector("input").checked = false;
    });
  }

  showSelectedExplanation(cssId) {
    let explanation = document.querySelector(cssId);
    if (explanation) {
      explanation.style.display = 'block';
    }
  }

  enableNextNavigation() {
    this.pageNavNext.removeAttribute('disabled');
  }

  showRetry() {
    this.element.querySelector('#submit-button').classList.add('display-none');
    this.element.querySelector('#retry-button').classList.remove('display-none');
  }

  showSubmit() {
    this.element.querySelector('#submit-button').classList.remove('display-none');
    this.element.querySelector('#retry-button').classList.add('display-none');
  }
}
